// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".repair-catalog-wrapper{padding-left:18px;padding-right:0}.repair-catalog-wrapper .catalog-box{justify-content:flex-end}.repair-catalog-wrapper .catalog-btn:before{content:\"\\e928\";font-family:fontello}.repair-catalog-wrapper .catalog-item-title{flex-direction:row-reverse}.repair-catalog-wrapper .catalog-item-title:after{content:\"\\e94e\"}.repair-catalog-wrapper .catalog-item .catalog-block{left:auto;right:223px}", ""]);
// Exports
module.exports = exports;
